export enum PermissionModule {
    ACCOUNT = 'ACCOUNT',
    ADMIN = 'ADMIN',
    CHECKLIST = 'CHECKLIST',
    INCIDENT = 'INCIDENT',
    INCIDENT_MANAGEMENT = 'INCIDENT_MANAGEMENT',
    LIVE_QM = 'LIVE_QM',
    PLANIT = 'PLANIT',
    REPORT = 'REPORT',
    REPORT_ARCHIVE = 'REPORT_ARCHIVE',
    REPORTING = 'REPORTING',
    SUMMARY = 'SUMMARY',
    SYSTEM_SETTINGS = 'SYSTEM_SETTINGS',
    INTERNATIONAL_PRODUCTS = 'INTERNATIONAL_PRODUCTS',
    //Reports
    PM_REPORT = 'PM_REPORT',
    CONTRIBUTION_REPORT = 'CONTRIBUTION_REPORT',
    SIGNAL_EVALUATION = 'SIGNAL_EVALUATION',
    DL_REPORT = 'DL_REPORT',
    DIRECTOR_REPORT = 'DIRECTOR_REPORT',
    BROADCASTING_VAN = 'BROADCASTING_VAN',
    DFB_CONTRIBUTION = 'DFB_CONTRIBUTION'
}

export const ReportPermissionModules = [

    PermissionModule.DIRECTOR_REPORT,
    PermissionModule.DL_REPORT,
    PermissionModule.PM_REPORT,
    PermissionModule.SIGNAL_EVALUATION,
    PermissionModule.CONTRIBUTION_REPORT,
    PermissionModule.BROADCASTING_VAN,
    PermissionModule.DFB_CONTRIBUTION
];

export const ProductionBasedPermissionModules = [
    PermissionModule.CHECKLIST,
    PermissionModule.INCIDENT_MANAGEMENT,
    PermissionModule.LIVE_QM,
    PermissionModule.REPORT,
    PermissionModule.REPORTING,
    PermissionModule.SUMMARY,
    PermissionModule.INTERNATIONAL_PRODUCTS
];

export const BasicPermissionModules = [
    PermissionModule.ACCOUNT,
    PermissionModule.ADMIN,
    PermissionModule.PLANIT,
    PermissionModule.SYSTEM_SETTINGS,
    PermissionModule.REPORT_ARCHIVE
];

export const ModalPermissionModules = [
    PermissionModule.CHECKLIST,
    PermissionModule.INCIDENT_MANAGEMENT,
    PermissionModule.LIVE_QM,
    PermissionModule.REPORT,
    PermissionModule.REPORT_ARCHIVE,
    PermissionModule.REPORTING,
    PermissionModule.SUMMARY,
    PermissionModule.INTERNATIONAL_PRODUCTS
];